import { CompanyAssetQuery, CompanyFindQuery, CompanyIdQuery } from './companyQuery';

export function isCompanyIdQuery(query: CompanyFindQuery): query is CompanyIdQuery {
    return Array.isArray((query as CompanyIdQuery).ids);
}

export function isCompanyAssetQuery(query: CompanyFindQuery): query is CompanyAssetQuery {
    return Array.isArray((query as CompanyAssetQuery).assets);
}
